module.exports = __webpack_public_path__ + "static/media/newfoil_case_web.bf4eb25c.png";